import { render, staticRenderFns } from "./AuthorityModal.vue?vue&type=template&id=09dc5878&scoped=true&"
import script from "./AuthorityModal.vue?vue&type=script&lang=js&"
export * from "./AuthorityModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityModal.vue?vue&type=style&index=0&id=09dc5878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc5878",
  null
  
)

export default component.exports